const RECORD = {
  // 词收集-同行关键词采集记录
  peerkeywordCollectRecord: "/api/v1/peer-keywords/record",
};
export default RECORD;
